import { ThemeContext } from '@/state/Theme';
import BlockLink from '../BlockLink';
import { type TextOnlyCardLinkBlockProps } from './TextOnlyCardLinkBlock.types';
import LinkTile from '../LinkTile';

const TextOnlyCardLinkBlock: React.FC<TextOnlyCardLinkBlockProps> = ({
  title,
  showTitle,
  content,
  linkText,
  linkExternal,
  linkInternal,
  items,
}) => (
  <ThemeContext.Consumer>
    {(theme) => (
      <div className="text-only-card-link-block">
        <div className="text-only-card-link-block__main">
          {showTitle && title && (
            <h2 className="text-only-card-link-block__heading">{title}</h2>
          )}
          {content && (
            <div
              className="text-only-card-link-block__content"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}
          {linkText && (
            <BlockLink
              arrowFill={theme.brandColor}
              linkExternal={linkExternal}
              linkInternal={linkInternal}
              linkText={linkText}
              extraClasses="content-tile__cta"
            />
          )}
        </div>
        <div className="text-only-card-link-block__cards">
          {items &&
            items.map((item, index) => (
              <LinkTile
                extraClass="link-tile--card"
                includeArticleMetadata
                key={index}
                position={index + 1}
                useTagAsSubtitle
                disableCard={false}
                {...item}
              />
            ))}
        </div>
      </div>
    )}
  </ThemeContext.Consumer>
);

export default TextOnlyCardLinkBlock;
